import styled from "styled-components";

export const CardWrapper = styled.div`
  padding: 16px 0px;
`;

export const TableWrapper = styled.div`
  width: 100%;
  overflow-x: auto;
  zoom: 1.5;
  padding: 8px;
`;

export const TableCellContent = styled.div`
  height: 24px;
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const DetailsWrapper = styled.div``;

export const DetailTitle = styled.div`
  width: 100%;
`;

export const DetailContent = styled.div`
  height: 18px;
  width: 100%;
  background-color: #eee;
  border-radius: 5px;
  padding: 4px;

  display: flex;
  justify-content: ${({ justify }) => justify || "flex-start"};
  align-items: center;

  font-family: Roboto;
`;

export const ButtonWrapper = styled.div`
  width: 100%;
`;

export const NoDataMessageWrapper = styled.div`
  width: 100%;
  padding: 24px;
  font-size: 16px;
  font-family: Roboto;

  display: flex;
  justify-content: center;
  align-items: center;
`;

export const FiltersWrapper = styled.div`
  width: 100%;
  padding: 16px 8px;
`;
